<div class="feedback-container">
  <ng-container [ngSwitch]="displayView">
    <ng-container *ngSwitchCase="'feedbackSelecting'">
      <div class="feedback-select-container">
        <div class="feedback-header">
          <span class="feedback-header-title">Rate this result</span>
          <u-icon
            [model]="{ type: 'font', value: 'icon-Windows-close' }"
            class="feedback-icon-close"
            [styles]="{ fontSize: '12px' }"
            (click)="closePopUp()"
          ></u-icon>
        </div>
        <div class="feedback-content">
          <div class="feedback-buttons-container">
            <div
              (click)="selectFeedback('Positive')"
              class="feedback-button like-icon"
              [class.like-icon-focus]="selectedIndex === 0"
              [class.like-active]="feedbackSelected === 'Positive'"
            >
              <u-icon [model]="{ type: 'font', value: 'icon-like' }" [styles]="{ fontSize: '18px' }"></u-icon>
            </div>
            <div
              (click)="selectFeedback('Negative')"
              class="feedback-button dislike-icon"
              [class.dislike-active]="feedbackSelected === 'Negative'"
              [class.dislike-icon-focus]="selectedIndex === 1"
            >
              <u-icon [model]="{ type: 'font', value: 'icon-dis-like' }" [styles]="{ fontSize: '18px' }"></u-icon>
            </div>
          </div>
          <span class="feedback-comment" [innerHTML]="feedbackComment"></span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="wrong-feedback-container">
        <div class="feedback-header">
          <div>
            <u-icon
              *ngIf="displayView === 'wrongReasonFree'"
              [model]="{ type: 'font', value: 'icon-chevron-left' }"
              [styles]="{ fontSize: '12px' }"
              (click)="goBack()"
              class="feedback-back-icon"
            ></u-icon>
            <span class="feedback-header-title">{{ 'What was wrong?' }}</span>
          </div>
          <u-icon
            [model]="{ type: 'font', value: 'icon-Windows-close' }"
            class="feedback-icon-close"
            [styles]="{ fontSize: '12px' }"
            (click)="closePopUp()"
          ></u-icon>
        </div>
        <ng-container [ngSwitch]="displayView">
          <ng-container *ngSwitchCase="'wrongReason'">
            <div class="feedback-reasons-container">
              <div
                *ngFor="let r of WRONG_FEEDBACK_REASONS; let i = index"
                class="feedback-reason"
                [ngClass]="{ 'feedback-reason-active': selectedIndex === i }"
                (click)="selectReason(i)"
              >
                {{ r }}
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'wrongReasonFree'">
            <div class="free-reason-container">
              <div class="feedback-reasons-container">
                <div class="feedback-reason">Other</div>
                <u-textarea
                  [styles]="{ width: '216px', height: '98px', maxHeight: '98px' }"
                  [rows]="4"
                  [cols]="49"
                  [placeholder]="'What was wrong'"
                  (onChange)="onReasonChange($event)"
                  #textAreaReason
                >
                </u-textarea>
              </div>
              <div class="wrong-feedback-buttons-container">
                <u-button
                  (onClick)="closePopUp()"
                  [label]="'Skip'"
                  [styles]="{ width: '72px' }"
                  type="secondary"
                  class="no-border-button"
                ></u-button>
                <u-button
                  (onClick)="onSubmitReason()"
                  [label]="'Submit'"
                  type="primary"
                  [styles]="{ width: '72px' }"
                  [disabled]="freeReasonModel?.trim()?.length < 11"
                ></u-button>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'wrongReasonFinal'">
            <div class="wrong-feedback-final">Thank you for your feedback!</div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>
